import React from 'react'

export default {
    /* ... un-comment
    [Actions.INSTRUMENT] : {
        // ... Fields
    }
    */
}